import React from 'react';
import { useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import Confirmation from 'src/components/Confirmation/Confirmation';
import Popup from 'src/components/Popup/Popup';
import SecondaryButton from '../../form-components/SecondaryButton/SecondaryButton';
import globalMessages from 'src/services/globalMessages';

const messages = defineMessages({
    pendingCount: {
        id: 'pendingCount',
        defaultMessage: '{n} függő foglalás'
    },
    jumpTo: {
        id: 'jumpTo',
        defaultMessage: 'Ugrás ide'
    },
    jumpToReservationEnd: {
        id: 'jumpToReservationEnd',
        defaultMessage: 'Vissza a véglegesítéshez'
    },
    confirmJumpToEnd: {
        id: 'confirmJumpToEnd',
        defaultMessage: 'A most megkezdett foglalás adatai el fognak veszni. Biztosan a Véglegesítés lépésre ugrasz?'
    }
});

export const enum PendingJumpType {
    Top,
    Bottom
}

interface IPendingJumpProps {
    type: PendingJumpType;
    reservationCount: number;
    action: () => void;
}

const JumpToEnd: React.FunctionComponent<IPendingJumpProps> = (props) => {
    const [isWarningVisible, setIsWarningVisible] = useState(false);
    const { type, action, reservationCount } = props;
    const caption = type === PendingJumpType.Top ? messages.jumpToReservationEnd : messages.jumpTo;
    const className = type === PendingJumpType.Top ? 'stepper__jump-to-pending--top' : 'stepper__jump-to-pending--bottom';

    return <>
        <div className={className}>
            <FormattedMessage {...messages.pendingCount} values={{ n: reservationCount }} />
            <SecondaryButton
                className="stepper__jump-to-pending-button"
                caption={caption}
                onClick={() => setIsWarningVisible(true)} />
        </div>
        <Popup closePopup={() => setIsWarningVisible(false)} visible={isWarningVisible}>
            <Confirmation
                description={messages.confirmJumpToEnd}
                affirmativeCaption={globalMessages.yes}
                affirmativeAction={action}
            />
        </Popup>
    </>
};

export default JumpToEnd;
